import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  getApplicationTimeZoneName,
  toApplicationDateTime,
} from '../lib/date-time';

const DATE_ONLY_FORMATS = [
  'shortDate',
  'mediumDate',
  'longDate',
  'fullDate',
];

const DATE_TIME_FORMATS = [
  'short',
  'medium',
  'long',
  'full',
  'shortTime',
  'mediumTime',
  'longTime',
  'fullTime',
];

@Pipe({
  name: 'localizedDate',
  pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    value: unknown,
    format: string = 'mediumDate'
  ): string | null {
    const dateTime = toApplicationDateTime(value);
    if (!dateTime.isValid) {
      return null;
    }

    const timezoneOffset = dateTime.toFormat('ZZZ');
    const locale =
      this.translateService.currentLang || 'en';

    const datePipe = new DatePipe(locale);

    const formattedDate = datePipe.transform(
      dateTime.toJSDate(),
      format,
      timezoneOffset
    );

    if (!formattedDate || !this.containsTime(format)) {
      return formattedDate;
    }

    const formattedDateWithoutTimezone =
      formattedDate.replace(
        / GMT[+-]\d{1,2}(?::?\d{2})?/,
        ''
      );
    const timeSuffix = locale.startsWith('de')
      ? ' Uhr'
      : '';
    const timezoneName =
      getApplicationTimeZoneName(dateTime);

    return `${formattedDateWithoutTimezone}${timeSuffix} ${timezoneName}`;
  }

  private containsTime(format: string): boolean {
    if (DATE_ONLY_FORMATS.includes(format)) {
      return false;
    }

    return (
      DATE_TIME_FORMATS.includes(format) ||
      /[Hhms]/.test(format)
    );
  }
}
